import { API_URL } from '../../constants';
import { Game } from '../../interfaces/Games.interface';

export const getGames = async (): Promise<Game[]> => {
  try {
    const response = await fetch(API_URL + '/api/games');
    if (!response.ok) {
      throw new Error('Error fetching games');
    }
    const games: Game[] = await response.json();
    return games;
  } catch (error) {
    console.error('Error fetching games:', error);
    return [];
  }
};
